

export default function InfoComponent() {
    return (
        <div className="info">
            <div>
                <div>
                Welcome! This application uses data taken from the City of Chicago Street Sweeping website for 2026. 
                You can use the links to the right to find your ward and zone. Once you've got your ward and zone, 
                fill out the form below. Once you've verified your email, the application will send you an email the day 
                before your ward and zone is scheduled for sweeping.
                </div>
                <div>
            

                </div>
            </div>
        </div>

    )

}
